import Rccreport from './Rccreport';
import image from './preview.png';

export const Image = image;
export default Rccreport;
